import config from './config'

const ENDPOINT = config.api[process.env.NODE_ENV].imageDomain

export function getAvatarUrl(avatarUrl) {
  let processedUrl = null

  if (!avatarUrl || avatarUrl.length < 5) {
    return processedUrl
  }

  if (avatarUrl.startsWith('http')) {
    return avatarUrl
  }

  if (avatarUrl.startsWith('~')) {
    processedUrl = avatarUrl.substr(2)
  }
  if (avatarUrl.startsWith('/')) {
    processedUrl = avatarUrl.substr(1)
  }

  return `${ENDPOINT}${processedUrl}`
}



// WEBPACK FOOTER //
// ./src/utils/processUrl.js